import { render, staticRenderFns } from "./MoreLink.vue?vue&type=template&id=2be5cd98&scoped=true&"
import script from "./MoreLink.vue?vue&type=script&lang=js&"
export * from "./MoreLink.vue?vue&type=script&lang=js&"
import style0 from "./MoreLink.vue?vue&type=style&index=0&id=2be5cd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5cd98",
  null
  
)

export default component.exports